import { rest } from "msw";
import { LOGIN_FORM_URL } from "@cart-app/consts";

export const loginFormHandler = [
  rest.get(LOGIN_FORM_URL.split("?")[0], (_, res, ctx) => {
    return res(ctx.xml("<div>Login form content</div>"));
  }),
];
